import {QueryClient, QueryClientProvider} from "@tanstack/react-query";
import {ReactQueryDevtools} from "@tanstack/react-query-devtools";
import React, {useState} from "react";
import config from './scripts/config';

const createQueryClient = () => {
    return new QueryClient({
        defaultOptions: {
            queries: {
                staleTime: 10 * 60 * 1000, // 10 minutes
                cacheTime: 30 * 60 * 1000, // 30 minutes
                retry: 0,
                refetchOnWindowFocus: true,
            },
        },
    });
};

const QueryClientProviders = ({children}) => {
    const [queryClient] = useState(createQueryClient);

    return (
        <QueryClientProvider client={queryClient}>
            {children}
            {config.REACT_APP_HOST ? (
                <ReactQueryDevtools initialIsOpen={false}/>
            ) : null}
        </QueryClientProvider>
    );
};

export default QueryClientProviders;
